import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Language } from '@app/core/models';
import { User } from '@app/core/domain';

@Component({
  selector: 'ingo-app-shell',
  templateUrl: './app-shell.component.html',
  styleUrls: ['./app-shell.component.scss']
})
export class AppShellComponent {

  @Input() dataReady: boolean = false;
  @Input() loading: boolean = false;
  @Input() hasError: boolean = false;
  @Input() isAuthenticated: boolean = false;
  @Input() accessBlocked: boolean;
  @Input() layout: string = 'default';
  @Input() user: User;
  @Input() currentLanguage: Language;
  @Input() currentRoute: Array<string> = [];
  @Output() onSelectLanguage: EventEmitter<Language> = new EventEmitter();
  @Output() onLogout: EventEmitter<void> = new EventEmitter();

  selectLanguage(language: Language) {
    this.onSelectLanguage.emit(language);
  }

  logOut(): void {
    this.onLogout.emit();
  }
}
